module.exports = __webpack_public_path__ + "static/media/photo-1521335639660-c569b17006f5.e389a076.jfif";